module.exports = __webpack_public_path__ + "static/media/Amazing Books.cb270652.png";